import { Injectable } from '@angular/core';
import JSONFormatter from 'json-formatter-js';
@Injectable()
export class JsonViewerService {

  constructor() { }


  isJsonString(str:any) {
    try {
      JSON.parse(str);
    } catch (e) {
      console.log("json parsing failed")
      return false;
    }
    return true;
  }

  formatJSON(data:any) {
    data = data.replace(/'/g, '\\"');
    data = this.sortJSONObjectByKeys(data);
    
    return this.removeRSMSFields(data);
  }

  sortJSONObjectByKeys(data:any) {
    try {
      if (this.isJsonString(data)) {
        data = JSON.parse(data);
      }
      this.sortObject(data);
    } catch (e) {
      console.log(e);
    }
    return data;
  }


  sortObject(o:any) {
    let sorted:any = {},
      key, a = [];
    try {
      for (key in o) {
        if (o.hasOwnProperty(key)) {
          a.push(key);
        }
      }
      a.sort();
      for (key = 0; key < a.length; key++) {
        sorted[a[key]] = o[a[key]];
      }
    } catch (e) {
      console.log(e);
    }
    return sorted;
  }

  convertToObject(data:any){
    if(typeof data == 'string')
    {
      return JSON.parse(data);
    } 
  return data;
  }

  formatJSONData(data:any, openJsonObjTreeLevel = 1) {
    try{
    return new JSONFormatter(data, openJsonObjTreeLevel);
    }
    catch(e){
      console.log(e);
    }
    return;
  }

  removeRSMSFields(json: any) {
    const rsmsKeys = ["id","fileID","rsmsStatus","errorCodeList", "reportDate", "createDate","createdDate","createdUser","updateDate","updatedDate","updatedUser","validationStatus","lastUpdatedBy", "groupName"];
    rsmsKeys.forEach(key => {
      let KeyName:string=key;
        delete json[KeyName];
    });
     return this.sortObject(json);
  }
}
